<div class="truckJourneyLoad">
    <div class="truckJourneyLoad-head">
        <div class="truckJourneyLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.load'}]"></span>
            <span> {{ truckJourneyLoad.loadId }}</span>
        </div>
        <div class="truckJourneyLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.deliveries'}]"></span>
            <span>&nbsp;<ng-container *ngFor="let delivery of getUniqueDeliveries(); let last = last"
                ><app-delivery-number [deliveryNumber]="delivery.number"
                                      [salesOrderNumber]="delivery.salesOrderNumber"
                                      displayType="text"></app-delivery-number><span *ngIf="!last"> ; </span></ng-container></span>
        </div>
        <div class="truckJourneyLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.stops-colon'}]"></span>
            <span> {{ truckJourneyLoad.stops.length }}</span>
        </div>
        <div class="truckJourneyLoad-head-actions">
            <i *ngIf="deletableLoad" (click)="onDeleteLoad.emit()" class="fa fa-trash"></i>
            <i *ngIf="editableLoad" (click)="editLoad()" class="fa fa-pen"></i>
        </div>
        <div *ngIf="isAssignmentLoad" class="truckJourneyLoad-head-truck">
            <i class="fa fa-truck"></i>
            <span *ngIf="truckJourneyLoad.vehicle">{{ truckJourneyLoad.vehicle }}</span>
            <span *ngIf="!truckJourneyLoad.vehicle" [i18n]="'truck-journeys.detail.unassigned'"></span>
        </div>
        <div *ngIf="isAssignmentLoad"
             class="truckJourneyLoad-head-status badge"
             [ngClass]="{'_info': truckJourneyLoad.status ===  AssignmentStatus.UNASSIGNED, '_success': truckJourneyLoad.status ===  AssignmentStatus.ASSIGNED}">
                {{ truckJourneyLoad.status }}
        </div>
    </div>
    <div class="truckJourneyLoad-block">
        <div *ngFor="let stop of truckJourneyLoad.stops" class="truckJourneyLoad-line">
            <div class="truckJourneyLoad-line-icon">
                <img [src]="stop.locationType === LocalLocationType.CHEP ? chepDepartureIconUrl : customerDepartureIconUrl" alt="">
            </div>
            <div class="truckJourneyLoad-line-item _location">
                <span>{{ stop.locationLabel }} - {{ stop.glid }}</span>
            </div>
            <div class="truckJourneyLoad-line-item _planned">
                <span class="font-bold" [i18n]="'truck-journeys.detail.planned-colon'"></span>
                <span> {{ {dateFrom: stop.plannedArrival, dateTo: stop.plannedDeparture} | dateInterval }}</span>
            </div>
            <div class="truckJourneyLoad-line-item">
                <app-truck-journey-delivery [deliveries]="stop.deliveries">
                </app-truck-journey-delivery>
            </div>
        </div>
    </div>
</div>
